@switch (pageName) {
    @case (skeletonPage.Home) {
        <div class="sk-main-padding">
            <div class="sk-center-content">
                <ms-skeleton-marquee />
                <div class="sk-left-center">
                    <ms-skeleton-top-sports />
                    <ms-skeleton-grid />
                </div>
            </div>
            @if (!device.isTablet) {
                <ms-skeleton-betslip />
            }
        </div>
    }
    @case (skeletonPage.Competition) {
        <div class="sk-comp-main-container">
            <div class="sk-left-center">
                <div [ngClass]="[device.isTablet ? 'sk-top-left-desk' : 'sk-top-left']">
                    @for (g of [0, 1]; track g) {
                        <div class="sk-comp-topsports">
                            <ms-skeleton-top-sports />
                        </div>
                    }
                </div>
                <div [ngClass]="[device.isTablet ? 'sk-comp-grid-desk' : 'sk-comp-grid']">
                    <ms-skeleton-grid />
                </div>
                @if (!device.isTablet) {
                    <div class="sk-comp-betslip-main">
                        <ms-skeleton-betslip class="sk-betslip-comp-margins" />
                    </div>
                }
            </div>
        </div>
    }
    @case (skeletonPage.Coupon) {
        <div class="sk-comp-main-container">
            <div class="sk-left-center">
                <div [ngClass]="[device.isTablet ? 'sk-top-left-desk' : 'sk-top-left']">
                    <div class="sk-comp-topsports">
                        <ms-skeleton-top-sports />
                    </div>
                </div>
                <div [ngClass]="[device.isTablet ? 'sk-comp-grid-desk' : 'sk-comp-grid']">
                    <ms-skeleton-grid />
                </div>
                @if (!device.isTablet) {
                    <div class="sk-comp-betslip-main">
                        <ms-skeleton-betslip class="sk-betslip-comp-margins" />
                    </div>
                }
            </div>
        </div>
    }
    @case (skeletonPage.Favourites) {
        <div class="sk-comp-main-container">
            <div class="sk-left-center">
                <div [ngClass]="[device.isTablet ? 'sk-fav-grid-desk' : 'sk-fav-grid']">
                    <ms-skeleton-grid />
                </div>
                @if (!device.isTablet) {
                    <div class="sk-comp-betslip-main">
                        <div class="sk-fav-minigames">
                            <ms-skeleton-betslip class="sk-betslip-comp-margins sk-mb-12" />
                            <ms-skeleton-minigames />
                        </div>
                    </div>
                }
            </div>
        </div>
    }
    @case (skeletonPage.Event) {
        <div class="sk-comp-main-container">
            <div class="sk-left-center">
                <div [ngClass]="[device.isTablet ? 'sk-top-left-desk' : 'sk-top-left']">
                    <div class="sk-comp-topsports">
                        <ms-skeleton-top-sports />
                    </div>
                </div>
                <div [ngClass]="[device.isTablet ? 'sk-event-grid-tab' : 'sk-event-grid']">
                    <ms-skeleton-events />
                </div>
                @if (!device.isTablet) {
                    <div class="sk-comp-betslip-main">
                        <ms-skeleton-betslip class="sk-betslip-comp-margins" />
                    </div>
                }
            </div>
        </div>
    }
    @case (skeletonPage.Racing) {
        <div class="sk-comp-main-container">
            <div class="sk-left-center">
                <div [ngClass]="[device.isTablet ? 'sk-gird-container sk-horse-today-tab' : 'sk-gird-container sk-horse-today']">
                    <div class="sk-nextrace-space">
                        @for (grid of [0, 1, 2]; track grid) {
                            <div class="sk-grid-first sk-p-12">
                                <div class="sk-grid-evets sk-h-12 sk-b-rad8"></div>
                                <div class="sk-line1 sk-h-12 sk-b-rad8"></div>
                                <div class="sk-grid-markets">
                                    <div class="sk-grid-left">
                                        @for (grid of [0, 1, 2]; track grid) {
                                            <div class="sk-grid-teams">
                                                <div class="sk-grid-team1 sk-h-12 sk-b-rad8"></div>
                                                <div class="sk-grid-team2 sk-h-12 sk-b-rad8"></div>
                                            </div>
                                        }
                                    </div>
                                    <div class="sk-grid-right">
                                        @for (i of [0, 1, 2]; track i) {
                                            <div class="sk-grid-right-team sk-b-rad3"></div>
                                        }
                                    </div>
                                </div>
                                <div class="sk-line2 sk-h-12 sk-b-rad8"></div>
                            </div>
                        }
                    </div>
                    @for (region of [0, 1]; track region) {
                        <div class="sk-region">
                            @for (meeting of [0, 1, 2]; track meeting) {
                                <div class="sk-meeting">
                                    <div class="sk-grid-evets sk-h-12 sk-b-rad8"></div>
                                    <div class="sk-line1 sk-h-12 sk-b-rad8"></div>
                                </div>
                            }
                        </div>
                    }
                </div>
                @if (!device.isTablet) {
                    <div class="sk-comp-betslip-main">
                        <div class="sk-fav-minigames">
                            <ms-skeleton-betslip class="sk-betslip-comp-margins sk-mb-12" />
                        </div>
                    </div>
                }
            </div>
        </div>
    }
    @case (skeletonPage.RacingTomorrow) {
        <div class="sk-comp-main-container">
            <div class="sk-left-center">
                <div [ngClass]="[device.isTablet ? 'sk-horse-tomorrow-tab' : 'sk-horse-tomorrow']">
                    @for (region of [0, 1, 2]; track region) {
                        <div class="sk-region">
                            @for (meeting of [0, 1, 2]; track meeting) {
                                <div class="sk-meeting">
                                    <div class="sk-grid-evets sk-h-12 sk-b-rad8"></div>
                                    <div class="sk-line1 sk-h-12 sk-b-rad8"></div>
                                </div>
                            }
                        </div>
                    }
                </div>
                @if (!device.isTablet) {
                    <div class="sk-comp-betslip-main">
                        <div class="sk-fav-minigames">
                            <ms-skeleton-betslip class="sk-betslip-comp-margins sk-mb-12" />
                        </div>
                    </div>
                }
            </div>
        </div>
    }
    @case (skeletonPage.RacingForecast) {
        <div class="sk-comp-main-container">
            <div class="sk-left-center">
                <div [ngClass]="[device.isTablet ? 'sk-fav-grid-desk sk-horse-race' : 'sk-fav-grid sk-horse-race']">
                    <div class="sk-meeting">
                        <div class="sk-grid-evets sk-h-12 sk-b-rad8"></div>
                        <div class="sk-line1 sk-h-12 sk-b-rad8"></div>
                    </div>
                    <ms-skeleton-grid [isHorseRaceForecast]="true" />
                </div>
                @if (!device.isTablet) {
                    <div class="sk-comp-betslip-main">
                        <div class="sk-fav-minigames">
                            <ms-skeleton-betslip class="sk-betslip-comp-margins sk-mb-12" />
                        </div>
                    </div>
                }
            </div>
        </div>
    }
}
